import React from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import media from '../../utils/media'
import RadioImage from './RadioImage'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  flex-wrap: wrap;
  max-height: 320px;
  max-width: 680px;
  align-content: space-between;
  @media (max-width: 770px) {
    flex-direction: row;
    flex-wrap: no-wrap;
  }
  ${media.mobileL`
    max-height: 100%;
  `}
`

export default function RadioImages({ answers, subtitleSize }) {
  const [{ currentValue }] = useStoreState(state => [state.quiz])
  const [{ answerQuestion }] = useStoreActions(state => [state.quiz])
  const t = useStoreState(state => state.locale.t)

  function getT(id, value) {
    if (!value.match(/[ap]\d/)) {
      if (id === undefined) {
        console.log(
          '%cTranslation error: id is required in Text Component',
          'color: red',
        )
        return null
      }
      return t(id, {})
    }
    return value
  }
  return (
    <>
      <Container>
        {answers.map(answer => {
          return (
            <RadioImage
              key={answer.title}
              title={answer.title}
              subtitle={answer.subtitle}
              subtitleSize={subtitleSize}
              color={answer.color}
              value={getT(answer.title, answer.value)}
              checked={
                getT(answer.title, answer.value) === currentValue
              }
              onChange={() => {
                answerQuestion(getT(answer.title, answer.value))
              }}
            />
          )
        })}
      </Container>
    </>
  )
}
